import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, catchError, map, of, take, tap } from "rxjs";
import { environment } from "../../../environments/environment";
import { IIndicacionAB } from "../../interfaces/temas";

@Injectable({
  providedIn: "root",
})
export class IndicacionesService {
  constructor(private http: HttpClient) {}
  
  guardarIndicacion(indicacion: IIndicacionAB): Observable<any> {
    return this.http
      .post(`${environment.acuerdos.agregarIndicacionesAB}`, indicacion)
      .pipe(
        tap((data) => console.log("API Response", data)),
        take(1),
        map((data) => {
          return data;
        }),
        catchError((error) => {
          console.error("Error en obtenerAcuerdos", error);
          return of({ error: true, acuerdos: [], items: 0 });
        })
      );
  }
}
